<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="form-page">
    <div class="form-page-header">
      <div class="form-page-header__icon">
        <i class="pi pi-file-edit"></i>
      </div>
      <div class="form-page-header__text">
        <h1 class="form-page-header__title">نصوص الموقع</h1>
        <p class="form-page-header__subtitle">تحرير الرسائل والنصوص المعروضة على الموقع</p>
      </div>
    </div>

    <div class="container-fluid">
      <form @submit.prevent="sendForm()">
        <!-- الصفحة الرئيسية -->
        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-home"></i></div>
            <div>
              <span class="form-card__title">الصفحة الرئيسية</span>
              <p class="form-card__subtitle">المحتوى الظاهر في أعلى صفحة الحجز</p>
            </div>
          </div>
          <div class="form-card__body">
            <div class="row g-4">
              <div class="col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">عنوان البداية</label>
                  <Editor v-model="texts.home_title" editorStyle="height: 180px" />
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">نص البداية</label>
                  <Editor v-model="texts.home_text" editorStyle="height: 180px" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- رسائل الحجز -->
        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-envelope"></i></div>
            <div>
              <span class="form-card__title">رسائل الحجز</span>
              <p class="form-card__subtitle">الرسائل التي تصل للطالب بعد تغيير حالة حجزه</p>
            </div>
          </div>
          <div class="form-card__body">
            <div class="row g-4">
              <div class="col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">رسالة قبول الطالب</label>
                  <Editor v-model="texts.confirm_text" editorStyle="height: 180px" />
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">رسالة رفض الطالب</label>
                  <Editor v-model="texts.reject_text" editorStyle="height: 180px" />
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">رسالة الطالب معلق</label>
                  <Editor v-model="texts.wait_text" editorStyle="height: 180px" />
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">الرسالة بعد إرسال الطلب</label>
                  <Editor v-model="texts.success_form_book" editorStyle="height: 180px" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- رسالة في انتظار الشهادة -->
        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-hourglass"></i></div>
            <div>
              <span class="form-card__title">رسالة في انتظار الشهادة</span>
              <p class="form-card__subtitle">الرسالة التي تصل للطالب عندما تكون حالة حجزه "في انتظار الشهادة"</p>
            </div>
          </div>
          <div class="form-card__body">
            <div class="row g-4">
              <div class="col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">عنوان الرسالة</label>
                  <Editor v-model="texts.waiting_certificate_title" editorStyle="height: 180px" />
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">نص الرسالة</label>
                  <Editor v-model="texts.waiting_certificate_message" editorStyle="height: 180px" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- إغلاق الموقع -->
        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-lock"></i></div>
            <div>
              <span class="form-card__title">إغلاق الموقع</span>
              <p class="form-card__subtitle">الرسالة التي تظهر عند إغلاق باب الحجز</p>
            </div>
          </div>
          <div class="form-card__body">
            <div class="form-field">
              <label class="field-label">نص إغلاق الموقع</label>
              <Editor v-model="texts.close_text_website" editorStyle="height: 180px" />
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-submit">
            <i class="pi pi-check"></i>
            تحديث النصوص
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import InputText from 'primevue/inputtext';
import Editor from 'primevue/editor';
import Breadcrumb from '@/components/global/breadcrumb.vue';

export default {
    name: "home-page",
    data() {
        return {
            texts: {
                home_title: '',
                home_text: '',
                confirm_text: '',
                reject_text: '',
                wait_text: '',
                waiting_certificate_title: '',
                waiting_certificate_message: '',
                success_form_book: '',
                close_text_website: '',
            },
            breadcrumbs: [
                { name: 'الرئيسية', path: '/' },
                { name: 'نصوص الموقع', path: '/website_text' },
            ]
        };
    },
    components: {
        InputText,
        Editor,
        Breadcrumb
    },
    methods: {
        // TEMP WORKAROUND: base64-encodes UTF-8 HTML so the Hostinger WAF never sees
        // raw HTML in the request body. Only used by sendForm() below for /website_texts.
        toBase64Utf8(str) {
            return btoa(unescape(encodeURIComponent(str ?? '')));
        },
        sendForm() {
            // TEMP DIAGNOSTIC: sending as JSON instead of multipart/form-data, with the
            // HTML fields base64-encoded to hide raw HTML from the Hostinger WAF. Revert
            // to FormData + raw fields once the 403 investigation is done.
            const payload = {
                home_title: this.toBase64Utf8(this.texts.home_title),
                home_text: this.toBase64Utf8(this.texts.home_text),
                confirm_text: this.toBase64Utf8(this.texts.confirm_text),
                reject_text: this.toBase64Utf8(this.texts.reject_text),
                wait_text: this.toBase64Utf8(this.texts.wait_text),
                waiting_certificate_title: this.toBase64Utf8(this.texts.waiting_certificate_title),
                waiting_certificate_message: this.toBase64Utf8(this.texts.waiting_certificate_message),
                success_form_book: this.toBase64Utf8(this.texts.success_form_book),
                close_text_website: this.toBase64Utf8(this.texts.close_text_website),
            };

            axios
                .post('/website_texts', payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    },
                })
                .then((response) => {
                    if (response.data.status == true) {
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "تم تحديث نصوص الموقع بنجاح",
                        });
                    }
                    else {
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: "حدث خطأ أثناء تحديث نصوص الموقع",
                        });
                    }
                })
                .catch((error) => {
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: error.response?.data?.message || error.message || "حدث خطأ أثناء تحديث نصوص الموقع",
                    });
                });
        },
        fetchWebText() {
            axios
                .get('/website_texts')
                .then((response) => {
                    const data = response.data.website_texts ?? {};
                    this.texts = {
                        home_title: data.home_title ?? '',
                        home_text: data.home_text ?? '',
                        confirm_text: data.confirm_text ?? '',
                        reject_text: data.reject_text ?? '',
                        wait_text: data.wait_text ?? '',
                        waiting_certificate_title: data.waiting_certificate_title ?? '',
                        waiting_certificate_message: data.waiting_certificate_message ?? '',
                        success_form_book: data.success_form_book ?? '',
                        close_text_website: data.close_text_website ?? '',
                    };
                })
                .catch((error) => {
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: error.response?.data?.message || error.message || "تعذر تحميل نصوص الموقع",
                    });
                });
        }
    },
    mounted() {
        this.fetchWebText();
    }
}
</script>